
import RootApiService from '@/services/api/RootApiService';
import { getLocale } from '@/i18n';

const STAT_DEFINITIONS = {
  clubs: { key: 'clubs', icon: 'bi bi-shop-window' },
  cities: { key: 'cities', icon: 'bi bi-geo-alt' },
  tournaments: { key: 'tournaments', icon: 'bi bi-trophy' },
  players: { key: 'players', icon: 'bi bi-people' },
  games: { key: 'games', icon: 'bi bi-controller' },
};
const HOMEPAGE_FIELDS = ['clubs', 'cities', 'tournaments', 'players'];

function formatStatValue(value) {
  const number = Number(value || 0);
  return Number.isFinite(number)
    ? new Intl.NumberFormat(getLocale() === 'ru' ? 'ru-RU' : 'en-US').format(number).replace(/\u00a0/g, ' ')
    : '0';
}

export function formatHomepageStats(data = {}) {
  return formatPublicStats(data, HOMEPAGE_FIELDS);
}

export function formatPublicStats(data = {}, fields = HOMEPAGE_FIELDS) {
  return fields.map((key) => ({
    ...STAT_DEFINITIONS[key],
    value: formatStatValue(data[key]),
  }));
}

export async function getPublicStats(fields = HOMEPAGE_FIELDS) {
  const res = await RootApiService.api.get('/public/stats', {
    skipToken: true,
    params: { fields: fields.join(',') },
  });

  return formatPublicStats(res?.data?.data || {}, fields);
}
